<!--suppress AngularNgOptimizedImage -->
<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
    </div>

    <div class="row clearfix">
      <!-- PANEL IZQUIERDO: FOTO + LISTADOS -->
      <div class="col-lg-4 col-md-12 left-panel">
        <!-- Header: NUEVO/EDITAR PACIENTE -->
        <div class="card card-patient-profile">
          <div class="profile-content">
            <!-- Imagen unica con fallback resuelta en TS -->
            <img class="profile-img" [src]="resolvedPanelImage" alt="Foto del Paciente" />

            <!-- Textos -->
            <div class="profile-text">
              <div class="profile-name">
                {{ param ? 'EDITAR' : 'NUEVO' }} PACIENTE
              </div>
              <div class="profile-subtext">
                Complete la informacion requerida
              </div>
            </div>
          </div>
        </div>

        <!-- Tarjeta separada: Patologias / Alergias / Moleculas -->
        <div class="card card-clinical" data-tour="patient-left-summary">
          <div class="card-header">
            <h2 class="card-title">ANTECEDENTES</h2>
          </div>

          <div class="card-body">
            <!-- Patologias -->
            <div class="clinical-section" *ngIf="patologiesNames.length > 0">
              <div class="section-title">
                <mat-icon>healing</mat-icon> PATOLOGIAS
              </div>
              <mat-list>
                <mat-list-item *ngFor="let row of patologiesNames; let i = index" class="clinical-item">
                  <span class="item-text" [matTooltip]="row" matTooltipPosition="above">{{ row }}</span>
                  <button class="close-btn" (click)="removePatology(i)" color="warn" mat-icon-button aria-label="Eliminar patologia">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-list-item>
              </mat-list>
            </div>

            <!-- Alergias -->
            <div class="clinical-section" *ngIf="allergiesNames.length > 0">
              <div class="section-title">
                <mat-icon>warning</mat-icon> ALERGIAS
              </div>
              <mat-list>
                <mat-list-item *ngFor="let row of allergiesNames; let i = index" class="clinical-item">
                  <span class="item-text" [matTooltip]="row" matTooltipPosition="above">{{ row }}</span>
                  <button class="close-btn" (click)="removeAllergy(i)" color="warn" mat-icon-button aria-label="Eliminar alergia">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-list-item>
              </mat-list>
            </div>

            <!-- Moleculas -->
            <div class="clinical-section" *ngIf="molesculesNames.length > 0">
              <div class="section-title">
                <mat-icon>science</mat-icon> MOLECULAS
              </div>
              <mat-list>
                <mat-list-item *ngFor="let row of molesculesNames; let i = index" class="clinical-item">
                  <span class="item-text" [matTooltip]="row" matTooltipPosition="above">{{ row }}</span>
                  <button class="close-btn" (click)="removeMolecule(i)" color="warn" mat-icon-button aria-label="Eliminar molecula">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-list-item>
              </mat-list>
            </div>

            <!-- Mensaje vacio -->
            <div
              class="empty-hint"
              *ngIf="
                (!patologiesNames || patologiesNames.length === 0) &&
                (!allergiesNames || allergiesNames.length === 0) &&
                (!molesculesNames || molesculesNames.length === 0)
              "
            >
              <mat-icon>info</mat-icon>
              Aun no has agregado antecedentes.
            </div>
          </div>
        </div>
      </div>
      <!-- FIN PANEL IZQUIERDO -->

      <!-- PANEL DERECHO: TODO EL FORMULARIO -->
      <div class="col-lg-8 col-md-12 right-panel">
        <div class="card px-4 py-4">
          <form [formGroup]="userForm" autocomplete="off" data-tour="patient-form">
            <div class="seccion-formulario">
              <div class="titulo-seccion">
                <mat-icon>lock</mat-icon>
                DATOS DE ACCESO
              </div>
              <div class="descripcion-seccion">
                CREDENCIALES QUE USARA EL PACIENTE PARA INGRESAR AL SISTEMA
              </div>

              <div class="row">
                <div class="col-md-4 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width no-uppercase">
                    <mat-label>USUARIO</mat-label>
                    <input aria-autocomplete="none" autocomplete="nope" formControlName="usr" matInput required data-tour="patient-usr"/>
                  </mat-form-field>
                  <div *ngIf="userForm.get('usr')?.touched && userForm.get('usr')?.invalid" class="custom-error-below">
                    <small *ngIf="userForm.get('usr')!.hasError('required')" class="text-danger">
                      EL NOMBRE DE USUARIO ES OBLIGATORIO.
                    </small>
                    <small *ngIf="userForm.get('usr')!.hasError('pattern')" class="text-danger">
                      SOLO LETRAS, NUMEROS, ESPACIOS, PUNTOS, GUIONES Y GUIONES BAJOS.
                    </small>
                  </div>
                </div>

                <div class="col-md-8 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width no-uppercase">
                    <mat-label>CORREO ELECTRONICO</mat-label>
                    <input aria-autocomplete="none" autocomplete="nope" email formControlName="email" matInput required data-tour="patient-email"/>
                  </mat-form-field>
                  <div *ngIf="userForm.get('email')?.touched && userForm.get('email')?.invalid" class="custom-error-below">
                    <small *ngIf="userForm.get('email')!.hasError('required')" class="text-danger">
                      EL CORREO ELECTRONICO ES OBLIGATORIO.
                    </small>
                    <small *ngIf="userForm.get('email')!.hasError('pattern')" class="text-danger">
                      INGRESE UNA DIRECCION DE CORREO VALIDA.
                    </small>
                  </div>
                </div>
              </div>
            </div>

            <div class="seccion-formulario">
              <div class="titulo-seccion">
                <mat-icon>person</mat-icon>
                DATOS DEL PACIENTE
              </div>
              <div class="descripcion-seccion">
                INFORMACION GENERAL DE CONTACTO Y DOMICILIO DEL PACIENTE
              </div>

              <div class="row">
                <div class="col-md-6 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>NOMBRE(S)</mat-label>
                    <input appUppercaseNoAccent aria-autocomplete="none" autocomplete="nope" formControlName="nombres" matInput required data-tour="patient-nombres"/>
                  </mat-form-field>
                  <div *ngIf="userForm.get('nombres')?.touched && userForm.get('nombres')?.invalid" class="custom-error-below">
                    <small *ngIf="userForm.get('nombres')!.hasError('required')" class="text-danger">
                      EL CAMPO NOMBRES ES OBLIGATORIO.
                    </small>
                    <small *ngIf="userForm.get('nombres')!.hasError('pattern')" class="text-danger">
                      SOLO SE PERMITEN LETRAS Y ESPACIOS.
                    </small>
                  </div>
                </div>

                <div class="col-md-6 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>PRIMER APELLIDO</mat-label>
                    <input appUppercaseNoAccent aria-autocomplete="none" autocomplete="nope" formControlName="primerApellido" matInput required data-tour="patient-apellido-paterno"/>
                  </mat-form-field>
                  <div *ngIf="userForm.get('primerApellido')?.touched && userForm.get('primerApellido')?.invalid" class="custom-error-below">
                    <small *ngIf="userForm.get('primerApellido')!.hasError('required')" class="text-danger">
                      EL PRIMER APELLIDO ES OBLIGATORIO.
                    </small>
                    <small *ngIf="userForm.get('primerApellido')!.hasError('pattern')" class="text-danger">
                      SOLO SE PERMITEN LETRAS Y ESPACIOS.
                    </small>
                  </div>
                </div>

                <div class="col-md-6 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>SEGUNDO APELLIDO</mat-label>
                    <input appUppercaseNoAccent aria-autocomplete="none" autocomplete="nope" formControlName="segundoApellido" matInput required data-tour="patient-apellido-materno"/>
                  </mat-form-field>
                  <div *ngIf="userForm.get('segundoApellido')?.touched && userForm.get('segundoApellido')?.invalid" class="custom-error-below">
                    <small *ngIf="userForm.get('segundoApellido')!.hasError('required')" class="text-danger">
                      EL SEGUNDO APELLIDO ES OBLIGATORIO.
                    </small>
                    <small *ngIf="userForm.get('segundoApellido')!.hasError('pattern')" class="text-danger">
                      SOLO SE PERMITEN LETRAS Y ESPACIOS.
                    </small>
                  </div>
                </div>

                <div class="col-md-6 mb-2">
                  <mat-form-field *ngIf="userForm.get('movil')" appearance="outline" class="example-full-width">
                    <mat-label>TELEFONO MOVIL</mat-label>
                    <ngx-mat-intl-tel-input
                      formControlName="movil"
                      [preferredCountries]="preferredCountries"
                      [enablePlaceholder]="true" data-tour="patient-movil">
                    </ngx-mat-intl-tel-input>
                  </mat-form-field>
                  <div *ngIf="userForm.get('movil')?.touched && userForm.get('movil')!.hasError('required')" class="custom-error-below">
                    <small class="text-danger">EL NUMERO DE CELULAR ES OBLIGATORIO.</small>
                  </div>
                </div>

                <!-- CODIGO POSTAL / COLONIA -->
                <div class="col-md-6 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>
                      {{ (userForm.get('settlementSearch')?.value ? 'COLONIA' : 'CODIGO POSTAL') | regionWord }}
                    </mat-label>

                    <input
                      matInput
                      [matAutocomplete]="auto"
                      formControlName="settlementSearch"
                      (blur)="onSettlementBlur()"
                      autocomplete="nope" data-tour="patient-cp-colonia"/>

                    <mat-autocomplete
                      #auto="matAutocomplete"
                      (optionSelected)="setSelectedSettlement($event.option.value)"
                      [displayWith]="displayFn">
                      <mat-option *ngFor="let option of settlements" [value]="option">
                        {{ option.asentamiento }}, {{ option.estado }} - CP: {{ option.codigoPostal }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                  <!-- deja estos errores, los usaremos en mas formularios -->
                  <div *ngIf="userForm.get('settlementSearch')?.touched && userForm.get('settlementSearch')!.hasError('required')" class="custom-error-below">
                    <small class="text-danger">EL CODIGO POSTAL ES OBLIGATORIO.</small>
                  </div>
                  <div *ngIf="userForm.get('settlementSearch')?.touched && userForm.get('settlementSearch')!.hasError('pattern')" class="custom-error-below">
                    <small class="text-danger">INGRESA UN CODIGO POSTAL VALIDO.</small>
                  </div>
                </div>

                <div class="col-md-6 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>DIRECCION</mat-label>
                    <textarea appUppercaseNoAccent aria-autocomplete="none" autocomplete="nope" formControlName="domicilio" matInput required data-tour="patient-domicilio"></textarea>
                  </mat-form-field>
                  <div *ngIf="userForm.get('domicilio')?.touched && userForm.get('domicilio')?.invalid" class="custom-error-below">
                    <small *ngIf="userForm.get('domicilio')!.hasError('required')" class="text-danger">
                      EL DOMICILIO ES OBLIGATORIO.
                    </small>
                    <small *ngIf="userForm.get('domicilio')!.hasError('pattern')" class="text-danger">
                      SOLO SE PERMITEN LETRAS, NUMEROS Y CARACTERES . , _ # / - ( ).
                    </small>
                  </div>
                </div>
              </div>
            </div>

            <!-- EMPRESA (se oculta si es doctor) -->
            <div class="seccion-formulario" *ngIf="!isDoctor && (!isParticular || showSucursalSelectForParticular)">
              <div class="titulo-seccion">
                <mat-icon>business</mat-icon>
                EMPRESA
              </div>
              <div class="descripcion-seccion">
                SELECCIONA EL GRUPO EMPRESARIAL Y SUCURSAL DONDE SE REGISTRA EL PACIENTE
              </div>

              <div class="row">
                <div class="col-md-6 mb-2" *ngIf="!isParticular">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>GRUPO EMPRESARIAL</mat-label>
                    <mat-select (selectionChange)="getBranchesByGemp()" formControlName="idGEMP" required>
                      <mat-option *ngFor="let row of businessGroups" [value]="row.idGEMP">
                        {{ row.nombre }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div *ngIf="userForm.get('idGEMP')?.touched && userForm.get('idGEMP')?.invalid" class="custom-error-below">
                    <small class="text-danger">{{ getErrorMessage() }}</small>
                  </div>
                </div>

                <div
                  class="mb-2"
                  *ngIf="!isParticular || showSucursalSelectForParticular"
                  [ngClass]="isParticular ? 'col-md-12' : 'col-md-6'">

                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>SUCURSAL</mat-label>
                    <mat-select formControlName="idSucursal" required>
                      <mat-option *ngFor="let row of branches" [value]="row.idSucursal">
                        {{ row.nombre }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <div *ngIf="userForm.get('idSucursal')?.touched && userForm.get('idSucursal')?.invalid" class="custom-error-below">
                    <small class="text-danger">{{ getErrorMessage() }}</small>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <form [formGroup]="patientForm" autocomplete="off" data-tour="patient-extra-form">
            <div class="seccion-formulario">
              <div class="titulo-seccion">
                <mat-icon>fingerprint</mat-icon>
                DATOS ADICIONALES DEL PACIENTE
              </div>
              <div class="descripcion-seccion">
                INFORMACION OFICIAL Y ANTECEDENTES RELEVANTES PARA LA IDENTIFICACION, REGISTRO Y SEGUIMIENTO MEDICO DEL PACIENTE
              </div>

              <div class="row">
                <!-- FECHA -->
                <div class="col-md-5 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>FECHA DE NACIMIENTO</mat-label>
                    <input [matDatepicker]="picker" [max]="maxBirthDate" formControlName="fechaNacimiento" matInput required data-tour="patient-fecha-nacimiento">
                    <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                  <div *ngIf="patientForm.get('fechaNacimiento')?.touched && patientForm.get('fechaNacimiento')?.invalid" class="custom-error-below">
                    <small *ngIf="patientForm.get('fechaNacimiento')!.hasError('required')" class="text-danger">
                      LA FECHA DE NACIMIENTO ES OBLIGATORIA.
                    </small>
                    <small *ngIf="patientForm.get('fechaNacimiento')!.hasError('maxDate')" class="text-danger">
                      LA FECHA DE NACIMIENTO NO PUEDE SER POSTERIOR A HOY.
                    </small>
                  </div>
                </div>

                <!-- ENTIDAD NACIMIENTO -->
                <div class="col-md-7 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>ENTIDAD DE NACIMIENTO</mat-label>
                    <mat-select formControlName="idEntidadNacimiento" required data-tour="patient-entidad-nacimiento">
                      <mat-option *ngFor="let row of federalEntity" [value]="row.idEntidad">
                        {{ row.nombre }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div *ngIf="patientForm.get('idEntidadNacimiento')?.touched && patientForm.get('idEntidadNacimiento')?.invalid" class="custom-error-below">
                    <small *ngIf="patientForm.get('idEntidadNacimiento')!.hasError('required')" class="text-danger">
                      LA ENTIDAD DE NACIMIENTO ES OBLIGATORIA.
                    </small>
                  </div>
                </div>

                <!-- SEXO NACIMIENTO -->
                <div class="col-md-5 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>SEXO DE NACIMIENTO</mat-label>
                    <mat-select formControlName="genero" required data-tour="patient-genero">
                      <mat-option value="F">FEMENINO</mat-option>
                      <mat-option value="M">MASCULINO</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div *ngIf="patientForm.get('genero')?.touched && patientForm.get('genero')?.invalid" class="custom-error-below">
                    <small *ngIf="patientForm.get('genero')!.hasError('required')" class="text-danger">
                      EL SEXO DE NACIMIENTO ES OBLIGATORIO.
                    </small>
                  </div>
                </div>

                <!-- GENERO -->
                <div class="col-md-7 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>GENERO</mat-label>
                    <mat-select formControlName="idGeneroVisible" data-tour="patient-genero-visible">
                      <mat-option [value]="null">SIN ESPECIFICAR</mat-option>
                      <mat-option *ngFor="let row of generosVisibles" [value]="row.id">
                        {{ row.descripcion | uppercase }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>


                <!-- TIPO IDENTIFICACION -->
                <div class="col-md-6 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>TIPO DE IDENTIFICACION</mat-label>
                    <mat-select
                      formControlName="idTipoIdentificacion"
                      required
                      data-tour="patient-tipo-identificacion"
                      (selectionChange)="onTipoIdentificacionChange()">
                      <mat-option [value]="ID_TIPO_IDENTIFICACION_SIN_ASIGNAR">SIN ASIGNAR</mat-option>
                      <mat-option [value]="ID_TIPO_IDENTIFICACION_PASAPORTE">PASAPORTE</mat-option>
                      <mat-option [value]="ID_TIPO_IDENTIFICACION_DOCUMENTO">{{ documentoIdentidadLabel }}</mat-option>
                      <mat-option [value]="ID_TIPO_IDENTIFICACION_REPRESENTANTE">{{ documentoRepresentanteLabel }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div *ngIf="patientForm.get('idTipoIdentificacion')?.touched && patientForm.get('idTipoIdentificacion')?.invalid" class="custom-error-below">
                    <small *ngIf="patientForm.get('idTipoIdentificacion')!.hasError('required')" class="text-danger">
                      EL TIPO DE IDENTIFICACION ES OBLIGATORIO.
                    </small>
                  </div>
                </div>

                <!-- NUMERO IDENTIFICACION -->
                <div class="col-md-6 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>NUMERO DE IDENTIFICACION</mat-label>
                    <input
                      appUppercaseNoAccent
                      aria-autocomplete="none"
                      autocomplete="nope"
                      formControlName="numeroIdentificacion"
                      matInput
                      required
                      [readonly]="numeroIdentificacionReadonly"
                      data-tour="patient-numero-identificacion"/>
                  </mat-form-field>
                  <div *ngIf="patientForm.get('numeroIdentificacion')?.touched && patientForm.get('numeroIdentificacion')?.invalid" class="custom-error-below">
                    <small *ngIf="patientForm.get('numeroIdentificacion')!.hasError('required')" class="text-danger">
                      EL NUMERO DE IDENTIFICACION ES OBLIGATORIO.
                    </small>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>BUSCAR PATOLOGIAS</mat-label>
                    <input
                      (keydown)="searchPatologiesByKeyPress($event)"
                      [(ngModel)]="searchPatologies"
                      [matAutocomplete]="autoPatologies"
                      aria-autocomplete="none"
                      autocomplete="nope"
                      formControlName="patologias"
                      matInput
                      name="patologias"
                      type="text"
                      data-tour="patient-patologias"
                    />
                    <mat-autocomplete
                      #autoPatologies="matAutocomplete"
                      (optionSelected)="setSelectedPatology($event.option.value)"
                      [displayWith]="displayFnPatologies">
                      @for (option of patologies; track option) {
                        <mat-option [value]="option">
                          {{ option.nameCIM10 }}
                        </mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                </div>

                <div class="col-md-12 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>BUSCAR ALERGIAS</mat-label>
                    <input
                      (keydown)="searchAllergiesByKeyPress($event)"
                      [(ngModel)]="searchAllergies"
                      [matAutocomplete]="autoAlergias"
                      aria-autocomplete="none"
                      autocomplete="nope"
                      formControlName="alergias"
                      matInput
                      name="alergias"
                      type="text"
                      data-tour="patient-alergias"
                    />
                    <mat-autocomplete
                      #autoAlergias="matAutocomplete"
                      (optionSelected)="setSelectedAllergy($event.option.value)"
                      [displayWith]="displayFnAllergy">
                      @for (option of allergies; track option) {
                        <mat-option [value]="option">
                          {{ option.nameAllergy }}
                        </mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                </div>

                <div class="col-md-12 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>BUSCAR MOLECULAS</mat-label>
                    <input
                      (keydown)="searchMolesculesByKeyPress($event)"
                      [(ngModel)]="searchMolescule"
                      [matAutocomplete]="autoMolecules"
                      aria-autocomplete="none"
                      autocomplete="nope"
                      formControlName="molecules"
                      matInput
                      name="molecules"
                      type="text"
                      data-tour="patient-moleculas"
                    />
                    <mat-autocomplete
                      #autoMolecules="matAutocomplete"
                      (optionSelected)="setSelectedMolecule($event.option.value)"
                      [displayWith]="displayFnMolescules">
                      @for (option of molescules; track option) {
                        <mat-option [value]="option">
                          {{ option.nameMolecule }}
                        </mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </form>

          <!-- ===== SECCION TUTOR (DESPUES DE DATOS ADICIONALES) ===== -->
          <div class="seccion-formulario">

            <div class="titulo-seccion">
              <mat-icon>supervisor_account</mat-icon>
              TUTOR
            </div>

            <div class="descripcion-seccion">
              SI EL PACIENTE ES MENOR DE EDAD ES OBLIGATORIO ASIGNAR TUTOR. SI ES MAYOR, ES OPCIONAL.
            </div>

            <!-- ✅ SI ES MAYOR DE EDAD: mostrar checkbox -->
            <div class="row" *ngIf="!esMenorDeEdad">
              <div class="col-md-12 mb-2 d-flex align-items-center gap-2">
                <mat-checkbox
                  [(ngModel)]="requiereTutor"
                  name="requiereTutor"
                  data-tour="patient-requiere-tutor">
                  SE REQUIERE TUTOR
                </mat-checkbox>
              </div>
            </div>

            <!-- ✅ Mostrar sección de tutor si:
                 - es menor (obligatorio)
                 - o es mayor y activó requiereTutor -->
            <div *ngIf="esMenorDeEdad || requiereTutor">

              <!-- ✅ SI YA HAY TUTOR: mostrar card resumen + X -->
              <!-- Resultado: tutor asignado -->
              <!-- Resultado: tutor asignado (RMD Premium) -->
              <div class="tutor-card" *ngIf="tutorAsignado">
                <div class="tutor-card-left">
                  <img
                    class="tutor-avatar"
                    [src]="tutorAsignado.imagen || 'assets/images/user/user_default.png'"
                    alt="Tutor"
                  />

                  <div class="tutor-info">
                    <div class="tutor-badge">
                      <mat-icon>supervisor_account</mat-icon>
                      TUTOR ASIGNADO
                    </div>

                    <div class="tutor-name">{{ tutorAsignado.nombreCompleto }}</div>

                    <div class="tutor-email" *ngIf="tutorAsignado.email">
                      <mat-icon>email</mat-icon>
                      {{ tutorAsignado.email }}
                    </div>

                    <div class="tutor-id" *ngIf="tutorAsignado.numeroIdentificacion">
                      <mat-icon>badge</mat-icon>
                      {{ documentoRepresentanteLabel }}: {{ tutorAsignado.numeroIdentificacion }}
                    </div>
                  </div>
                </div>

                <button type="button" class="btn-remove-tutor" (click)="quitarTutor()">
                  <mat-icon>close</mat-icon>
                </button>
              </div>

              <!-- ✅ SI NO HAY TUTOR: mostrar input + buscar -->
              <div class="row tutor-row" *ngIf="!tutorAsignado">
                <!-- Email -->
                <div class="col-md-8 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width no-uppercase">
                    <mat-label>CORREO ELECTRONICO DEL TUTOR</mat-label>
                    <input
                      matInput
                      aria-autocomplete="none"
                      autocomplete="nope"
                      [(ngModel)]="tutorEmail"
                      name="tutorEmail"
                      (blur)="onTutorEmailBlur()"
                      data-tour="patient-tutor-email"
                    />
                  </mat-form-field>

                  <!-- ✅ Error SOLO cuando corresponde -->
                  <div *ngIf="showTutorRequiredError" class="custom-error-below">
                    <small class="text-danger">
                      ES OBLIGATORIO ASIGNAR UN TUTOR PORQUE EL PACIENTE ES MENOR DE EDAD.
                    </small>
                  </div>
                </div>

                <!-- Acciones -->
                <div class="col-md-4 mb-2 tutor-actions">
                  <button mat-raised-button color="primary" type="button"
                          (click)="buscarTutorPorEmail()"
                          [disabled]="tutorSearching || tutorAssigning">
                    <span *ngIf="!tutorSearching">BUSCAR</span>
                    <span *ngIf="tutorSearching">BUSCANDO...</span>
                  </button>
                </div>
              </div>

              <!-- Tutor no encontrado -->
              <div *ngIf="tutorNoEncontrado && !tutorAsignado" class="tutor-empty">
                NO SE ENCONTRO UN TUTOR CON ESE CORREO.
              </div>

            </div>
          </div>
          <!-- ===== FIN SECCION TUTOR ===== -->

          <form [formGroup]="archiveForm" autocomplete="off">
            <div class="seccion-formulario">
              <div class="titulo-seccion">
                <mat-icon>settings</mat-icon>
                CONFIGURACION
              </div>
              <label class="fw-semibold">IMAGEN DE PERFIL (JPG, PNG, JPEG)</label>
              <!-- 10 KB maximo como acordamos -->
              <app-file-upload
                formControlName="imagen"
                [acceptedTypes]="'image/*'"
                [externalSrc]="param ? (userImage ?? null) : null"
                [circle]="true"
                [targetKB]="10"
                [initialMaxSize]="320"
                data-tour="patient-imagen">
              </app-file-upload>
            </div>

            <button
              data-tour="patient-btn-guardar"
              (click)="confirmAdd()"
              [disabled]="(!userForm.valid || !patientForm.valid) && !param"
              [ngClass]="{
                'button-custom': true,
                'disabled': (!userForm.valid || !patientForm.valid) && !param
              }"
              color="primary"
              mat-button>
              {{
                (!userForm.valid || !patientForm.valid) && !param
                  ? 'FORMULARIO INCOMPLETO'
                  : (param ? 'EDITAR USUARIO' : 'CREAR USUARIO')
              }}
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
